import ImmutableConverter from 'HOCs/ImmutableConverter';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { locationSelector } from 'reducers/router/selectors';
import {
  rawActiveProjectIdSelector,
  projectsListSelector,
  projectsColorSelector
} from '../../reducers/projects/selectors';
import ProjectSelectorBar from './component';

const mapStateToProps = (state) => ({
  activeProjectId: rawActiveProjectIdSelector(state),
  colors: projectsColorSelector(state),
  location: locationSelector(state),
  projects: projectsListSelector(state)
});

const withConnect = connect(mapStateToProps);

export default compose(withConnect)(ImmutableConverter(ProjectSelectorBar));
